import { cmsServiceQuery, useAxiosCmsInstance, usePoQuery } from '@gov-nx/api';
import type { ServiceCode } from '@gov-nx/module/service';
import { useConfiguration } from '../configuration/useConfiguration';
import { useAppLanguage } from '@gov-nx/core/hooks';
import { useCmsStore } from '@gov-nx/store';

interface useCmsServiceQueryProps {
	code: ServiceCode;
}

export const useCmsServiceQuery = ({ code }: useCmsServiceQueryProps) => {
	const { cmsKeyCache } = useConfiguration();
	const { language } = useAppLanguage();
	const { axiosCmsInstance } = useAxiosCmsInstance();
	const saveCmsService = useCmsStore('saveCmsService');

	const serviceQuery = usePoQuery({
		queryKey: ['cms-service', code, cmsKeyCache, language],
		queryFn: () =>
			cmsServiceQuery(axiosCmsInstance, {
				cmsKeyCache,
				code,
				locale: language,
			}),
		onSuccess: (data) => saveCmsService(code, data),
		retry: 0,
		cacheTime: 0,
		refetchOnWindowFocus: false,
	});

	return serviceQuery;
};
